import { alpha, useTheme } from '@mui/material/styles';
import { useResponsive } from "../../../hooks/useResponsive";
import { Box, Stack } from "@mui/material";
import { bgGradient } from "../../../theme/css";


type Props = {
    title?: string;
    image?: string;
    children: React.ReactNode;
  };
  
function AuthLayout({ children, image, title }: Props) {
  
    const theme = useTheme();
  
    const mdUp = useResponsive('up', 'md');
  
  
    const renderContent = (
      <Stack
        sx={{
          width: 1,
          mx: 'auto',
          maxWidth: 680,
          px: { xs: 2, md: 8 },
          
        }}
      >
        {children}
      </Stack>
    );
  
    const renderSection = (
      <Stack
        flexGrow={1}
        spacing={10}
        alignItems="center"
        justifyContent="center"
        sx={{
          ...bgGradient({
            color: alpha(
              theme.palette.background.default,
              theme.palette.mode === 'light' ? 0.88 : 0.94
            )
          }),
        }}
      >
  
        <Box
          component="img"
          alt="auth"
          src={image || '/assets/background/bizmed-logo.png'}
          sx={{
            maxWidth: {
              xs: 480,
              lg: 560,
              xl: 720,
            },
          }}
        />
  
      </Stack>
    );
  
    return (
      <Stack
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{
          height: '80vh',
        }}
      >
  
        {mdUp && renderSection}
        {renderContent}
      </Stack>
    );
  }
  
    export default AuthLayout;